import React from 'react';
import { Label } from '../ui/label';
import { Activity } from 'lucide-react';
import { StatusOption } from './ExamFormControls';

const PosturalReactionsSection = ({ formData, handleChange, readOnly }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 p-3 bg-[#F8F7F4] rounded-lg">
        <Activity className="w-4 h-4 text-[#4B6651]" />
        <span className="text-sm text-[#5C5F5C]">
          Test proprioception and hopping in all four limbs.
        </span>
      </div>

      <div>
        <Label className="text-[#2A2C2A] font-medium mb-3 block">Proprioception (Knuckling)</Label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { field: 'proprioception_lf', label: 'Left Front' },
            { field: 'proprioception_rf', label: 'Right Front' },
            { field: 'proprioception_lh', label: 'Left Hind' },
            { field: 'proprioception_rh', label: 'Right Hind' },
          ].map(({ field, label }) => (
            <div key={field} className="space-y-2">
              <Label className="text-sm text-[#5C5F5C]">{label}</Label>
              <div className="flex gap-1 flex-wrap">
                <StatusOption value="normal" label="N" selected={formData[field] === 'normal'} onChange={(v) => handleChange(field, v)} readOnly={readOnly} />
                <StatusOption value="abnormal" label="Abn" selected={formData[field] === 'abnormal'} onChange={(v) => handleChange(field, v)} readOnly={readOnly} />
                <StatusOption value="unable_to_evaluate" label="U/E" selected={formData[field] === 'unable_to_evaluate'} onChange={(v) => handleChange(field, v)} readOnly={readOnly} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <Label className="text-[#2A2C2A] font-medium mb-3 block">Hopping</Label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { field: 'hopping_lf', label: 'Left Front' },
            { field: 'hopping_rf', label: 'Right Front' },
            { field: 'hopping_lh', label: 'Left Hind' },
            { field: 'hopping_rh', label: 'Right Hind' },
          ].map(({ field, label }) => (
            <div key={field} className="space-y-2">
              <Label className="text-sm text-[#5C5F5C]">{label}</Label>
              <div className="flex gap-1 flex-wrap">
                <StatusOption value="normal" label="N" selected={formData[field] === 'normal'} onChange={(v) => handleChange(field, v)} readOnly={readOnly} />
                <StatusOption value="abnormal" label="Abn" selected={formData[field] === 'abnormal'} onChange={(v) => handleChange(field, v)} readOnly={readOnly} />
                <StatusOption value="unable_to_evaluate" label="U/E" selected={formData[field] === 'unable_to_evaluate'} onChange={(v) => handleChange(field, v)} readOnly={readOnly} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PosturalReactionsSection;
